<template>
    <app-pop-up id="person-update-photo">
        <template slot="body">
            <app-upload-or-take-photo
                id="upload-or-take-photo"
                :multiple="false"
                v-model="fileOrPhotos"
            ></app-upload-or-take-photo>
        </template>
        <template slot="buttons">
            <b-btn variant="confirm" @click="updatePhoto" :disabled="inProgress"
                ><i class="fa fa-save"></i> Actualizar</b-btn
            >
        </template>
    </app-pop-up>
</template>
<script>
import UploadOrTakePhoto from "../../UI/Controls/Photos/UploadOrTakePhoto";
import PopUp from "../../UI/Controls/PopUp/PopUp";
import peopleRepository from "../../../repositories/people.repository";
export default {
    name: "person_update_photo",
    components: {
        appUploadOrTakePhoto: UploadOrTakePhoto,
        appPopUp: PopUp
    },
    props: {
        value: {
            default: () => false
        },
        person: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        fileOrPhotos: ""
    }),
    watch: {
        value(val) {
            if (!this.person)
                return toastr.error("Primero debe seleccionar una persona");

            !!val && this.$bus.$emit("person-update-photo.open");
            !val && this.$bus.$emit("person-update-photo.close");
        }
    },
    methods: {
        async updatePhoto() {
            const { files, photos } = this.fileOrPhotos;
            if (!photos.length && !files.length)
                return toastr.warning("Debe tomar o seleccionar la foto");

            const formData = new FormData();

            formData.append("photo", photos);
            formData.append("document", this.person.document);
            formData.append("clientId", this.client.id);
            files.forEach(item => formData.append("files[]", item));

            const pr = { ...peopleRepository };
            try {
                const { data } = await pr.updatePersonPhoto(formData);
                const { status, msg, photoUrl } = data;

                if (!status) return toastr.error(msg);

                this.$emit("on-update", data.photoUrl);
                this.$bus.$emit("person-update-photo.close");
                this.$bus.$emit("upload-or-take-photo.clean");
                this.fileOrPhotos = "";
                this.$emit("input", false);
                toastr.success("Foto actualizada satisfactoriamente");
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al actualizar la foto [${err.message}]`
                );
            } finally {
            }
        }
    },
    mounted() {}
};
</script>
